import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase } from './ApiBase'

export namespace ApiTaCt070 {
  export namespace Get {
    // API Request
    export interface Request {
      // 成績表総合画面から遷移する場合は前者のパラメータを、
      // もくじ画面から遷移する場合は後者のパラメータを用いる
      query:
        | {
            answerCommentaryId: string // 答案ID
          }
        | {
            unitId: string // 配信単位ID
            subunitId: string // 単元ID
            pieceId: string // コマID
          }
    }

    // API Response
    /** API-TA-CT-070の成功時レスポンスはapplication/pdfであることに注意！ */
    export type Response = ArrayBuffer
    /**
     * エラーレスポンスについては他のAPIと同様のJSONだが、
     * Axiosからはバイナリとして返却されることに注意
     * */
    export type ResponseError = ArrayBuffer
  }

  // API Path
  const path: string = '/ta/unitAnswers'

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, Get.ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<Get.ResponseError, R>
    ): Promise<R | null> {
      // API呼び出し
      // 成功・失敗レスポンスはともにバイナリで返却されるため、TypeValidationは行わない
      return this.callbackWrapper<Get.Response, Get.ResponseError, R>(
        api.get<Get.Response>(path, { params: params.query, responseType: 'arraybuffer' }),
        successHandler,
        errorHandler,
        undefined,
        undefined
      )
    }
  }
}
